<script setup lang="ts">
import SidebarLayout from '@/layout/SidebarLayout.vue';
</script>

<template>
  <SidebarLayout>
    <div class="flex min-h-full flex-col items-center justify-center gap-2 px-6 py-24">
      <h1 class="text-2xl font-bold text-gray-900" data-test="screen-notfound">
        Whoops! Page Not Found
      </h1>
    </div>
  </SidebarLayout>
</template>
